module.exports = __webpack_public_path__ + "static/media/controller-widget.a5110cec.svg";